export default __webpack_public_path__ + "static/media/2schrodinger_schat.f0cdfa88.mp3";